import { render, staticRenderFns } from "./gameNewRecom.vue?vue&type=template&id=7d9352ce&scoped=true&"
import script from "./gameNewRecom.vue?vue&type=script&lang=ts&"
export * from "./gameNewRecom.vue?vue&type=script&lang=ts&"
import style0 from "./gameNewRecom.vue?vue&type=style&index=0&id=7d9352ce&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d9352ce",
  null
  
)

export default component.exports